import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutosizeModule } from 'ngx-autosize';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { DiaryPicturePreviewModalModule } from '../diary-picture-preview-modal/diary-picture-preview-modal.module';
import { DiaryCardComponent } from './diary-card.component';

@NgModule({
  declarations: [DiaryCardComponent],
  exports: [DiaryCardComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgxBootstrapIconsModule,
    AutosizeModule,
    CarouselModule,
    DiaryPicturePreviewModalModule,
    TooltipModule,
  ],
})
export class DiaryCardModule {}
